module.exports = __webpack_public_path__ + "static/media/welcome-manage.ab5226d0.png";